import {RootStore} from './index';
import {makeAutoObservable, action} from "mobx"
import Token from "../helper/Token";
import {EnumUserType} from "../enum/EnumUserType";
import UserModel from "../model/UserModel";
import {ISelect} from "../interface/ISelect";
import ClientModel from "../model/ClientModel";
import QuizModel from "../model/QuizModel";
import moment from "moment";
import {isMobile, AndroidView} from 'react-device-detect';

export class MainStore {
    private rootStore: RootStore | undefined;
    templateTp: boolean = false;
    MainAboutIsHide: boolean = true;
    isAuth = false;
    user: any;
    myUser: any;
    goodMode: string = '';
    TradePoint = {
        value: {
            value: '',
            label: ''
        },
        option: [],
        detail: {}
    };
    userInfo: any;
    clientId: number = 58451;
    clientOpen = false;
    redirectUrl = '';
    openQuiz = false
    openConfirmConsent = false
    showPrivacyPolicy = false
    disableConfirmButton = true
    firstConfirmInfo = false
    secondConfirmInfo = false
    dateconfirmpersonaldata = null

    selectedClient: ISelect = {value: '', label: 'Клиент'};
    optionsClient: ISelect[] = [];
    isMobileAndroid = false
    scoresAmount = 0
    scoresFrozen = 0
    scoresDate = ""
    arrayScoresDate = []
    closeUnfreezeDate = "0001-01-01"
    closeScoresFrozen = 0
    burnDate = []
    includeUserLoyaltyProgram = false
    isPopupShowBonus= false

    showIsPopupShowBonus = false




    constructor(rootStore?: RootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
        this.setGoodMode();
    }

    @action setClientOpen = (open: boolean) => {
        this.clientOpen = open;
    }


    setGoodMode() {
        if (window.location.host === "localhost:3000") {
            let m = localStorage.getItem('goodMode');
            if (m) {
                this.goodMode = m;
            } else {
                this.goodMode = 'DEV';
                localStorage.setItem('goodMode', 'DEV');
            }

        }
    }

    @action changeGoodMode = () => {
        if (this.goodMode === 'DEV') {
            this.goodMode = 'PROD';
            localStorage.setItem('goodMode', 'PROD');
        } else {
            this.goodMode = 'DEV';
            localStorage.setItem('goodMode', 'DEV');
        }
    }

    @action
    setDataUser(jwt: any) {
        this.user = jwt;
        this.user.name = this.decodeBase64(jwt.name);
        this.user.last_name = this.decodeBase64(jwt.last_name);
        this.user.second_name = this.decodeBase64(jwt.second_name);
        if (this.getUserType() === EnumUserType.ourUser || this.getUserType() === EnumUserType.ourAdmin) {
            this.templateTp = true;
        } else {
            this.clientId = parseInt(this.user.clientId);
        }
    }

    decodeBase64(str: string) {
        return decodeURIComponent(escape(window.atob(str)));
    }

    @action
    setMyUser = (result: any) => {
        this.myUser = null;
        if (result.data.row.length) {
            this.myUser = result.data.row[0];
        }
        localStorage.setItem('setMyUser', JSON.stringify(result));
    }

    @action
    setRedirectUrl = (url: string) => {
        this.redirectUrl = url;
    }

    @action toggleMainAboutIsHide = () => {
        this.MainAboutIsHide = !this.MainAboutIsHide;
    }

    @action
    clearRedirectUrl = () => {
        this.redirectUrl = '';
    }

    getClientId() {
        return this.clientId;
    }

    getUserType() {
        if (this.user?.type) {
            return this.user.type;
        }
        return EnumUserType.clientUser;
    }

    getUserId = () => {
        if (this.user?.id) {
            return this.user.id;
        }
        return 0;
    }
    @action handleClose = () => this.openQuiz = false;
    @action handleCloseConfirmConsent = () => this.openConfirmConsent = false;
    @action handleCloseShowPrivacyPolicy = () => this.showPrivacyPolicy = false;
    @action handleOpenShowPrivacyPolicy = () => this.showPrivacyPolicy = true;

    @action handleChangeConfirmInfo = (item: string) => {
        if (item === "firstConfirm") {
            this.firstConfirmInfo = !this.firstConfirmInfo
        } else {
            this.secondConfirmInfo = !this.secondConfirmInfo
        }
        this.checkConfirm(this.firstConfirmInfo, this.secondConfirmInfo)
    }
    @action checkConfirm = (firstConfirm: boolean, secondConfirm: boolean) => {
        if (firstConfirm && secondConfirm) {
            this.disableConfirmButton = false
        } else {
            this.disableConfirmButton = true
        }
    }
    @action updateConfirmInfo = () => {
        let date = moment(Date()).utc().format("YYYY-MM-DD HH:mm")
        let ob = {dateConfirmPersonalData: date}
        UserModel.updateUser(this.user.id, ob, this.setUpdateConfirmInfo, this.setError)
        this.openConfirmConsent = false
    }

    @action removeConfirmInfo = () => {

        let ob = {dateConfirmPersonalData: null}
        UserModel.updateUser(this.user.id, ob, this.setUpdateConfirmInfo, this.setError)
        this.dateconfirmpersonaldata = null
    }

    @action setUpdateConfirmInfo = (result: any) => {
        if (result) {
            localStorage.removeItem('setInfoUser');
            this.init()
        }
    }

    getDateConfirmPersonalData() {
        return this.dateconfirmpersonaldata;
    }

    setOpenConfirmConsent() {
        return this.openConfirmConsent = true
    }
    @action
    getLoyaltyUpdateInfo() {
        UserModel.getInfo(this.clientId, this.setLoyaltyUpdateInfo, this.setError)
    }

    setLoyaltyUpdateInfo = (result: any) => {
        this.includeUserLoyaltyProgram = false
        this.scoresAmount = 0
        this.scoresFrozen = 0
        this.closeUnfreezeDate = "0001-01-01"
        this.closeScoresFrozen = 0
        if (result) {
            if (result.data[0].loyalty[0].loyalty_program_report_by_client.loyalty_programs.length){
                this.includeUserLoyaltyProgram = true
                this.scoresAmount =result.data[0].loyalty[0].loyalty_program_report_by_client.scoresAmount
                this.scoresFrozen = result.data[0].loyalty[0].loyalty_program_report_by_client.scoresFrozen
                this.closeUnfreezeDate = result.data[0].loyalty[0].loyalty_program_report_by_client.closeUnfreezeDate
                this.closeScoresFrozen = result.data[0].loyalty[0].loyalty_program_report_by_client.closeScoresFrozen
            }
        }
    }

    @action
    setInfoUser = (result: any) => {
        this.scoresAmount = 0
        this.scoresFrozen = 0
        this.closeUnfreezeDate = "0001-01-01"
        this.closeScoresFrozen = 0
        this.includeUserLoyaltyProgram = false

        if (result) {
            this.userInfo = result?.data[0];
            result?.data[0]?.tradepoints.map((item: any) => {
                this.TradePoint.option.push({
                    // @ts-ignore
                    value: item.tradepointid,
                    // @ts-ignore
                    label: item.tradepointname,
                });
            });
            if(this.userInfo.loyalty[0].loyalty_program_report_by_client.loyalty_programs.length){
                this.includeUserLoyaltyProgram = true
                this.scoresAmount = this.userInfo.loyalty[0].loyalty_program_report_by_client.scoresAmount
                this.scoresFrozen = this.userInfo.loyalty[0].loyalty_program_report_by_client.scoresFrozen
                this.closeUnfreezeDate = this.userInfo.loyalty[0].loyalty_program_report_by_client.closeUnfreezeDate
                this.closeScoresFrozen = this.userInfo.loyalty[0].loyalty_program_report_by_client.closeScoresFrozen
            }
            this.setPoint(result?.data[0]?.tradepoints[0]?.tradepointid);
            this.TradePoint.value = {
                // @ts-ignore
                value: result?.data[0]?.tradepoints[0]?.tradepointid,
                // @ts-ignore
                label: result?.data[0]?.tradepoints[0]?.tradepointname,
            };
            localStorage.setItem('setInfoUser', JSON.stringify(result));
            if (result?.data[0]?.dateconfirmpersonaldata === null) {
                this.openConfirmConsent = true
            } else {
                this.dateconfirmpersonaldata = result?.data[0]?.dateconfirmpersonaldata
            }
        }
        // this.checkPopupShowBonus()
    }
    @action
    setInfoUserLoyalty = (result: any) => {
        this.arrayScoresDate = []
        if (result.data && result.data.row.length){
            for (let i=0; i< result.data.row.length; i++){
                let a = result.data.row[i].scoresFrozen.includes("-")
                let b= Number(result.data.row[i].scoresAmount)
                if (!a || b !== 0 ){
                    // @ts-ignore
                    this.arrayScoresDate.push(result.data.row[i])
                }
            }
        }
    }

    @action
    setLastQuiz = (result: any) => {
        if (result.data === "") {
            this.openQuiz = true
        }
    }

    @action
    setMobileAndroidShow = ()=> {
        this.isMobileAndroid = false
    }

    @action
    init() {

        this.isMobileAndroid = !!(isMobile && AndroidView);

        let active = localStorage.getItem('activeClient');
        if (active) {
            this.selectedClient = JSON.parse(active);
            // @ts-ignore
            this.clientId = parseInt(this.selectedClient?.value);
        }

        let token = localStorage.getItem("token");
        if (token?.length) {
            let jwt = Token.getTokenData(token);
            if (jwt.exp > Date.now() / 1000) {
                this.isAuth = true;
                this.setDataUser(jwt);
                // let setInfoUser = localStorage.getItem('setInfoUser');
                let setMyUser = localStorage.getItem('setMyUser');
                if (setMyUser?.length){
                    this.setMyUser(JSON.parse(setMyUser));
                }
                // if (setInfoUser?.length) {
                //     this.setInfoUser(JSON.parse(setInfoUser));
                // } else {
                    UserModel.getInfo(this.clientId, this.setInfoUser, this.setError)
                    UserModel.getInfoLoyalty(this.clientId, this.setInfoUserLoyalty, this.setError)
                    UserModel.getMyUsers(this.setMyUser, this.setError)// получаем пользователей
                    QuizModel.getLast(this.setLastQuiz, this.setError)

                // }
                this.reloadApp();
                // подключаем клиентов в список
                ClientModel.getClients(this.setClients, this.setError);
            } else {
                this.rootStore?.authStore.logout();
            }
        }

    }


    @action
    setClients = (result: any) => {

        let active = localStorage.getItem('activeClient');
        if (this.templateTp) {
            let actV = {
                value: '0',
                label: 'Все клиенты',
            };
            this.optionsClient.push(actV);
            if (!active) {
                this.setActiveClient(actV);
                active = localStorage.getItem('activeClient')
            }

        }
        if (result.data?.length) {
            result.data.map((item: any) => {
                this.optionsClient.push({
                    value: item?.id,
                    label: item?.id + '|' + item['name'],
                });
                return item;
            });

            if (active) {
                this.selectedClient = JSON.parse(active);
                // @ts-ignore
                this.clientId = parseInt(this.selectedClient?.value);
            } else {
                this.setActiveClient({
                    value: result.data[0]?.id,
                    label: result.data[0]['name'],
                });
            }
        }
    }

    setActiveClient(act: any) {
        this.selectedClient = act;
        this.clientId = parseInt(act.value);
        localStorage.setItem("activeClient", JSON.stringify(act));
    }

    @action
    SetPasswordDemo() {
        this.rootStore?.authStore.setDemo();
    }

    @action
    getLoyalty() {
        // UserModel.getInfoLoyalty(this.clientId, this.setInfoUserLoyalty, this.setError)
    }

    @action
    setError = (error: any) => {
        console.log(error)
    }


    @action onChangeInputTradePoint = (e: any, link: boolean = true) => {
        this.TradePoint.value = e;
        this.setPoint(this.TradePoint.value.value);
        if (link) {
            this.rootStore?.pageBasketStore.setSelectedOptionPoints(e, false);
        }
    }

    public setPoint = (value: string) => {
        this.TradePoint.detail = this.userInfo.tradepoints.filter((item: any) => item.tradepointid === value);
    }


    // HeaderMenuTp
    @action setSelectedOptionClient = (e: any) => {
        this.selectedClient = e;
        this.clientId = parseInt(e.value);
        localStorage.setItem("activeClient", JSON.stringify(e));
        this.reloadApp();
        this.rootStore?.pageBasketStore.initMain();
        this.rootStore?.pageMainStore.init();
        this.rootStore?.componentCatalogSectionStore.initMain(this.clientId);
        this.rootStore?.pageCatalogStore.reloadMain();
        this.rootStore?.pageOrderStore.init();
        this.rootStore?.pageReturnStore.init();
        this.rootStore?.pageMassageStore.init();
        this.rootStore?.pageCardStore.reloadMain(); 
    }

    @action reloadApp() {
        // Инициализацыя выбода меню разделов
        this.rootStore?.componentCatalogSectionStore.init(this.clientId);
        // отображаем количистов товаров в корзине
        this.rootStore?.componentBasketCountStore.init();
        // отоброжаем количиство не прочитанных сообщений
        this.rootStore?.pageMassageStore.setCountShowTop();
    }

    @action
    setPopupShowBonus = () => {
        this.isPopupShowBonus = false
        localStorage.setItem("showBonusB2B", "true")
    }

    @action
    checkPopupShowBonus = () => {
        if (localStorage.getItem("showBonusB2B") && localStorage.getItem("showBonusB2B")==="true"){
            this.isPopupShowBonus = false
        }else if (this.isAuth && !localStorage.getItem("showBonusB2B")) {
            this.isPopupShowBonus = true
        }
    }
    @action handleClosePopupShowBonus = () => {
        this.isPopupShowBonus = false;
        this.showIsPopupShowBonus = false;
        localStorage.setItem("showBonusB2B", "true")
    }
    @action setShowIsPopupShowBonus = () => {
        this.showIsPopupShowBonus = true
    }

}